<h3
   *ngIf="!(this.facultiesDetails?.totalFaculties == 0 && name == undefined)"
   class="filtersContainer"
>
   <h4>{{ 'app.institutions' | translate }}</h4>
   <div class="selectors">
      <div>
         <input
            [placeholder]="'placeholders.search_by_name' | translate"
            [(ngModel)]="name"
            (ngModelChange)="titleFilter()"
            type="text"
            name="searchByName"
         />
      </div>
      <button class="reportBtn" (click)="resetFilter()">{{ 'general.reset' | translate }}</button>
   </div>
</h3>
<div *ngIf="this.facultiesDetails?.totalFaculties != 0">
   <table class="table-university">
      <tr>
         <th class="bold">{{ 'general.name' | translate }}</th>
         <th class="bold">{{ 'general.description' | translate }}</th>
         <th class="bold">{{ 'general.departments' | translate }}</th>
         <th class="bold"> {{ 'general.submissions' | translate }}</th>
         <th class="bold">{{ 'general.edit' | translate }}</th>
      </tr>
      <tr
         class="shadow"
         *ngFor="
            let faculty of this.facultiesDetails?.faculties
               | paginate
                  : {
                       itemsPerPage: pageSize,
                       currentPage: page,
                       totalItems: this.facultiesDetails?.totalFaculties
                    }
         "
      >
         <td>
            {{ faculty.name }}
         </td>
         <td [title]="faculty.description" class="addEllipsis">
            {{ faculty.description }}
         </td>
         <td>
            {{ faculty.Department.length }}
         </td>
         <td>
            {{ faculty.submissions || 0 }}
         </td>
         <td>
            <i (click)="openModal(faculty.id)" class="far fa-edit editButton"></i>
         </td>
      </tr>
   </table>
</div>
<div class="paginationContainer">
   <div></div>
   <pagination-controls
   *ngIf="this.facultiesDetails?.totalFaculties != 0"
   class="num"
   (pageChange)="changePage($event)"
   responsive="true"
   previousLabel=""
   nextLabel=""
></pagination-controls>
   <div class="center"
   *ngIf="!(this.facultiesDetails?.totalFaculties == 0 && name == undefined)"
   >
      <button class="reportBtn" (click)="registerFacultyModal()" >
         <i class="fas fa-plus"></i>{{ 'app.register_schools' | translate }}
      </button>
   </div>
</div>


<div
   class="zeroState"
   *ngIf="this.facultiesDetails?.totalFaculties == 0 && name != undefined"
>
   No schools found
</div>
<div
   class="zero-state"
   *ngIf="this.facultiesDetails?.totalFaculties == 0 && name == undefined"
>
   <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
   <h5 class="bold">{{ 'app.there_are_no_schools_registered_in_your_instutition' | translate }}.<br/><span class="clickable" routerLink="/administrator/register-module/faculty-register">{{ 'general.click_here' | translate }}</span> {{ 'app.to_begin_registering_your_first_institution' | translate }}.</h5>
</div>
